import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Icon, type IconName } from '@/components/common/Icon';

interface PortalShortcutCardProps {
  iconName: IconName;
  titleKey: string;
  descriptionKey: string;
  route: string;
}

export function PortalShortcutCard({
  iconName,
  titleKey,
  descriptionKey,
  route,
}: PortalShortcutCardProps) {
  const { t } = useTranslation('clients');
  const title = t(titleKey);
  return (
    <Card as="section" className="lg:hidden">
      <div className="flex items-center gap-3">
        <span className="w-9 h-9 rounded-xl bg-zoovpalelavender text-zooviolet flex items-center justify-center shrink-0">
          <Icon name={iconName} />
        </span>
        <div className="min-w-0 flex-1">
          <h2 className="text-sm font-bold text-zooindigo">{title}</h2>
          <p className="text-xs text-zoomuted mt-0.5">{t(descriptionKey)}</p>
        </div>
        <Button asChild variant="outline" size="chip" className="shrink-0 min-h-[44px]">
          <Link
            to={route}
            aria-label={t('portal.pages.account.shortcutActionAriaLabel', { title: title })}
          >
            {t('portal.pages.account.shortcutAction')}
          </Link>
        </Button>
      </div>
    </Card>
  );
}
